import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Portal } from '../models/portal.model';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  static Settings: Portal;
  static ApiUrl: string;
  static FayeHost: string;
  private http: HttpClient;

  constructor(private httpBackEnd: HttpBackend) {
    this.http = new HttpClient(httpBackEnd);
  }

  load() {
    const domain =
      window.location.hostname == 'localhost'
        ? 'dev.brn.ai'
        : window.location.hostname;
    // fix for new live domain
    // force live
    // const domain = 'brn.ai',
    const url = 'https://api.brn.ai/portal?domain=' + domain;
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(url)
        .toPromise()
        .then((response: any) => {
          PortalService.Settings = response.portal;
          // Default
          PortalService.ApiUrl =
            response.portal.environment === 'dev'
              ? 'http://api-dev.brn.ai'
              : 'https://api.brn.ai';
          // Enable live api
          // PortalService.ApiUrl = 'https://api.brn.ai';
          PortalService.FayeHost =
            response.portal.environment == 'dev'
              ? 'https://faye-dev.brn.ai/faye'
              : 'https://faye.brn.ai/faye';
          resolve();
        })
        .catch((response: any) => {
          reject('Could not get portal settings');
        });
    });
  }
}
